var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { attrs: { id: "top-menu" } },
    [
      _c(
        "div",
        { staticClass: "navbar-logo-lite" },
        [_c("SVGNavbarLogo", { staticClass: "logo-lite-svg" })],
        1
      ),
      _vm._v(" "),
      _c("div", [_c("router-view", { attrs: { name: "lowerBarLeft" } })], 1),
      _vm._v(" "),
      _c(
        "router-link",
        {
          staticClass: "line-nav-option",
          attrs: { to: "/configurator/projects", title: "Авторизация" }
        },
        [_vm._v("\n        " + _vm._s(_vm.userName) + "\n    ")]
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "line-nav-option",
          attrs: { title: "Помощь" },
          on: {
            click: function($event) {
              return _vm.showModal("modal-feedback")
            }
          }
        },
        [_vm._v("\n        Помощь\n    ")]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }